import styled, { css } from 'styled-components';
import { Media } from 'assets/Mixins.style';
import { Container as CommonContainer } from 'assets/Common/Layout';

export const Wrapper = styled.header`
  display: block;
  width: 100%;
  position: relative;
  background: ${props => props.theme.background};
  box-shadow: ${props => props.theme.boxShadow};
  padding: ${props => props.theme.padding.default};
  z-index: ${props => props.theme.zIndex};

  ${Media.lg`
    padding: ${props => props.theme.padding.lg};
  `}

  ${Media.md`
    padding: ${props => props.theme.padding.md};
  `}

  ${Media.sm`
    padding: ${props => props.theme.padding.sm};
  `}
`;

export const Container = styled.div`
  ${CommonContainer}
`;

export const Box = styled.div`
  display: grid;
  width: 100%;
  grid-gap: ${props => props.theme.gridGap};
`;

export const LogoHolder = styled.div`
  display: flex;
  width: auto;
  grid-area: 1 / 1 / 2 / 2;
  align-items: ${props => props.theme.alignItems || 'center'};

  ${Media.lg`
    grid-area: 1 / 1 / 2 / 2;
  `}
`;

export const NavHolder = styled.div`
  display: block;
  width: 100%;
  grid-area: 1 / 2 / 2 / 3;

  ${Media.lg`
    grid-area: 2 / 1 / 3 / 2;
  `}
`;

export const MenuHolder = styled.div`
  position: relative;
  display: block;
  width: 100%;
  grid-area: 2 / 1 / 3 / 3;
  z-index: 2;

  ${Media.lg`
    grid-area: 3 / 1 / 4 / 2;
  `}
`;

export const TogglesHolder = styled.div`
  display: none;
  width: 100%;
  text-align: right;

  ${Media.lg`
    display: block;
  `}
`;

export const ToggleButton = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 5px;
  margin: 2px;
  color: ${props => props.theme.color};
  transition: 0.2s all;
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.colorOnHover};
    background: ${props => props.theme.backgroundOnHover};
  }

  ${props =>
    props.toggle &&
    css`
      color: ${props => props.theme.colorOnToggle};
      background: ${props => props.theme.backgroundOnToggle};
    `}
`;
